export const accommRsvInDayTripActions = {
  SET_RSV_VALUE: '@@accommRsv/SET_RSV_VALUE',
};
